import { http } from "./http";

export const auctionRuleTemplatesApi = {
  list: (params) =>
    http.get("/auction-rule-templates", { params }).then((r) => r.data),

  getById: (id) =>
    http.get(`/auction-rule-templates/${id}`).then((r) => r.data),

  create: (payload) =>
    http.post("/auction-rule-templates", payload).then((r) => r.data),

  update: (id, payload) =>
    http.put(`/auction-rule-templates/${id}`, payload).then((r) => r.data),
};
